import { defineComponent as n, openBlock as l, createBlock as r, unref as m, mergeProps as p, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const v = /* @__PURE__ */ n({
  name: "IconImage",
  __name: "IconImage",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (l(), r(m(d), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "M9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M4.5 4.25A2.25 2.25 0 0 0 2.25 6.5v11a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-11a2.25 2.25 0 0 0-2.25-2.25h-15M3.75 16.892V17.5a.75.75 0 0 0 .75.75h1.215l3.1-2.755-1.8-1.505-3.265 2.902m6.198-2.405-2.136-1.786a1.25 1.25 0 0 0-1.632.025l-2.43 2.16V6.5A.75.75 0 0 1 4.5 5.75h15a.75.75 0 0 1 .75.75v7.899l-4.44-3.7a1.25 1.25 0 0 0-1.63.026l-4.232 3.762m5.068-2.498L7.973 18.25H19.5a.75.75 0 0 0 .75-.75v-1.149l-5.234-4.362",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
